export default __webpack_public_path__ + "static/media/IMG23.2671eeaf.jpg";